/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Author/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Author({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/More/AppointmentHistory/Content/Main/Content/Entry/Author"
  
}) {
let entryAuthorValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'author',
format: fromFormat.personName,
})
let constantData = 'appointments@greyfinch.com'
let aggregateData = fromAggregate.any(entryAuthorValueData, constantData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="entry.author"
 format="/Data/format.js personName"
 data="'appointments@greyfinch.com'"
 aggregate="/Data/aggregate.js any"
 text={aggregateData}
 weight="semibold"
/>
{children}
</React.Fragment>)
}